import React from "react"
import { useSelector, useDispatch } from "react-redux"
import ToastAlerts from "./ToastAlerts"
import { setToastBoxStatus } from "../../redux/ToastBoxSlice"
import { checkCircleIcon } from "../../constants/icons"

const ToastManager = () => {
  const { status, description } = useSelector((state) => state.toastBox)
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(setToastBoxStatus(false))
  }

  return (
    <ToastAlerts
      showToast={status}
      setShowToast={handleClose}
      text={description}
      icon={checkCircleIcon}
      toastVariant="success"
    />
  )
}

export default ToastManager
